<div [class]="wrapperClass" [style.height]="scrollHeight">
  <p-table
    #rowReference
    [columns]="tableConfig.columnsConfig"
    [value]="tableConfig.data"
    [styleClass]="tableConfig.class"
    [globalFilterFields]="globalFilterFields"
    [(selection)]="selectedData"
    (onRowSelect)="rowSelectedOrUnselect()"
    (onRowUnselect)="rowSelectedOrUnselect()"
    [tableStyle]="tableConfig.style"
    [rowGroupMode]="tableConfig?.rowGroupOptions ? 'subheader' : null"
    [dataKey]="tableConfig?.rowGroupOptions?.dataKey || null"
    [groupRowsBy]="tableConfig?.rowGroupOptions?.groupRowsBy || null"
    [scrollable]="scrollHeight ? true : false"
    [scrollHeight]="scrollHeight"
    [rows]="tableConfig.virtualScrollLazyLoadOptions ? tableConfig.virtualScrollLazyLoadOptions.rows : null"
    [virtualScroll]="tableConfig.virtualScrollLazyLoadOptions && tableConfig?.data?.length >= tableConfig.virtualScrollLazyLoadOptions.rows ? true : false"
    [virtualScrollItemSize]="tableConfig.virtualScrollLazyLoadOptions ? tableConfig.virtualScrollLazyLoadOptions.virtualScrollItemSize : 46"
    [lazy]="tableConfig.virtualScrollLazyLoadOptions ? true : false"
    (onLazyLoad)="onLazyLoading($event)"
    (onSort)="sortLazyLoading($event)"
    >
    <ng-template pTemplate="header" let-columns>
      <ng-content select="[otherHeaderRows]"></ng-content>
      <tr [class]="tableConfig.headerClass">
        @if (tableConfig.checkbox && !lazyLoadingEnabled) {
          <th
            style="max-width: 2rem"
            pFrozenColumn
            [frozen]="true"
            [style.right]="dir === 'rtl' ? 0 : 'unset'"
            [alignFrozen]="dir === 'rtl' ? 'left' : 'right'"
            >
            <p-checkbox [binary]="true" [ngModel]="checkboxState === true" [indeterminate]="checkboxState === null" (click)="onSelectAllChanged()"></p-checkbox>
          </th>
        }
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.sortable ? col.name : null" [class]="col.class" [style]="col.style">
            {{ col.label | translate }} @if (col.sortable) {
            <p-sortIcon [field]="col.name"></p-sortIcon>
          }
        </th>
      }
      @if ((tableConfig.menuOptions?.length || tableConfig?.buttonsColumn?.length || tableConfig?.quickActionButton) && !lazyLoadingEnabled) {
        <th
          [alignFrozen]="dir === 'rtl' ? 'right' : 'left'"
          pFrozenColumn
          [frozen]="true"
        ></th>
      }
    </tr>
    @if (summaryRow) {
      <ng-container [ngTemplateOutlet]="summaryRow"></ng-container>
    }
  </ng-template>
  <ng-template [pTemplate]="tableConfig?.rowGroupOptions ? 'groupheader' : 'body'" let-row let-index="rowIndex" let-columns="columns" let-expanded="expanded">
    <tr
      class="fz-14"
      [class.yabi-row-clickable]="tableConfig?.rowClickActionName"
      [id]="'entity-id-' + row.id"
      [style]="{ height: tableConfig?.virtualScrollLazyLoadOptions ? tableConfig.virtualScrollLazyLoadOptions.rowHeight : 'auto' }"
      [style.background-color]="matchesRowBackgroundCondition(row) && !tableConfig.class.includes('striped') ? rowBackgroundColor : 'auto'"
      >
      @if (tableConfig.checkbox && !lazyLoadingEnabled) {
        <td
          style="max-width: 2rem"
          class="checkbox-td"
          [style.right]="dir === 'rtl' ? 0 : 'unset'"
          [alignFrozen]="dir === 'rtl' ? 'left' : 'right'"
          pFrozenColumn
          [frozen]="true"
          >
          <p-tableCheckbox [value]="row"></p-tableCheckbox>
        </td>
      }
      @for (col of columns; track col; let IsFirst = $first) {
        <td
          [class]="col.class"
          [style]="col.style"
          (click)="onCellClick(row, col)"
          [pEditableColumn]="col.editableConfig || null"
          [dir]="!col.editableConfig && col.type === 'dateRange' ? 'rtl' : 'unset'"
          >
          @if (IsFirst && tableConfig?.rowGroupOptions && showExpanded(row)) {
            <button
              type="button"
              pButton
              pRipple
              [pRowToggler]="row"
              class="p-button-text p-button-rounded p-button-plain mr-2"
              [icon]="expanded ? 'pi pi-chevron-down' : dir === 'ltr' ? 'pi pi-chevron-right' : 'pi pi-chevron-left'"
              [attr.aria-label]="'COMMON.BUTTONS.TOGGLE_ROW' | translate"
              [attr.aria-expanded]="expanded"
            ></button>
          }
          @if (!col.editableConfig) {
            <app-table-cell
              [tableConfig]="tableConfig"
              [row]="row"
              [col]="col"
              [labelCallbackFunction]="labelCallbackFunction"
              [iconCallbackFunction]="iconCallbackFunction"
            ></app-table-cell>
          }
          @if (col.editableConfig && !formGroups) {
            <app-editable-table-cell [tableConfig]="tableConfig" [row]="row" [col]="col" [index]="index"></app-editable-table-cell>
          }
          @if (col.editableConfig && formGroups) {
            <app-editable-table-cell
              [tableConfig]="tableConfig"
              [row]="row"
              [col]="col"
              [index]="index"
              [form]="formGroups[index]"
              [formControlNameInput]="col.name"
            ></app-editable-table-cell>
          }
        </td>
      }
      @if ((tableConfig.menuOptions?.length || tableConfig?.quickActionButton) && !lazyLoadingEnabled) {
        <td
          [alignFrozen]="dir === 'rtl' ? 'right' : 'left'"
          pFrozenColumn
          [frozen]="true"
          style="display: flex; justify-content: flex-end; align-items: center; gap: 4px"
          >
          @if (tableConfig.quickActionButton) {
            <button
              type="button"
              [class]="tableConfig.quickActionButton.iconClass || 'btn btn-icon'"
              [style.visibility]="tableConfig?.showRowMenuConditionCallback && !tableConfig?.showRowMenuConditionCallback(row) ? 'hidden' : 'visible'"
              (click)="$event.stopPropagation(); selectedData = row; onAction.emit({ action: tableConfig.quickActionButton.actionName, model: selectedData })"
              [pTooltip]="tableConfig.quickActionButton.tooltip"
              [tooltipPosition]="tableConfig.quickActionButton.tooltipPosition || 'bottom'"
              >
              <i [class]="tableConfig.quickActionButton.icon"></i>
            </button>
          }
          @if (tableConfig.menuOptions?.length) {
            <button
              #body
              (click)="selectedData = row; menu.toggle($event)"
              type="button"
              [style.visibility]="tableConfig?.showRowMenuConditionCallback && tableConfig?.showRowMenuConditionCallback(row) ? 'visible' : 'hidden'"
              [style.background-color]="matchesRowBackgroundCondition(row) && !tableConfig.class.includes('striped') ? rowBackgroundColor : 'auto'"
              class="btn btn-icon"
              >
              <i class="pi pi-ellipsis-h"></i>
            </button>
            <p-menu #menu appendTo="body" [tabindex]="undefined" [model]="initItems(row)" [popup]="true"></p-menu>
          }
        </td>
      }
      @if (tableConfig.buttonsColumn?.length && !lazyLoadingEnabled) {
        <td
          [alignFrozen]="dir === 'rtl' ? 'right' : 'left'"
          pFrozenColumn
          [frozen]="true"
          [style]="'max-width:' + menuColumnWidth"
          >
          <div class="row-inline">
            @for (option of tableConfig.buttonsColumn; track option) {
              @if (option.hasPermission && this.checkIfMenuConditionHasTrue(option, row)) {
                <button
                  *hasPermission="option.hasPermission"
                  [disabled]="option.disabledByKeyOperatorAndValue ? this.checkIfMenuConditionHasTrue(option, row) : false"
                  (click)="$event.preventDefault(); selectedData = row; onAction.emit({ action: option.actionName, model: selectedData })"
                  [style.background-color]="
                    matchesRowBackgroundCondition(row) && !tableConfig.class.includes('striped') && row[option.keyCondition] === option?.valueCondition
                      ? rowBackgroundColor
                      : index % 2 === 1 && tableConfig.class.includes('striped')
                        ? '#eceef9'
                        : 'auto'
                  "
                  type="button"
                  [class]="option.iconClass"
                  [pTooltip]="option.tooltip"
                  [tooltipPosition]="option.tooltipPosition"
                  [id]="'row-' + option.actionName + '-' + row.id"
                  >
                  <i [class]="option.icon"></i>
                </button>
              } @else {
                @if (this.checkIfMenuConditionHasTrue(option, row)) {
                  <button
                    (click)="selectedData = row; onAction.emit({ action: option.actionName, model: selectedData })"
                  [style.background-color]="
                    matchesRowBackgroundCondition(row) && !tableConfig.class.includes('striped') && row[option.keyCondition] === option?.valueCondition
                      ? rowBackgroundColor
                      : index % 2 === 1 && tableConfig.class.includes('striped')
                        ? '#eceef9'
                        : 'auto'
                  "
                    type="button"
                    [class]="option.iconClass"
                    [pTooltip]="option.tooltip"
                    [tooltipPosition]="option.tooltipPosition"
                    [id]="'row-' + option.actionName + '-' + row.id"
                    >
                    <i [class]="option.icon"></i>
                  </button>
                }
              }
            }
          </div>
        </td>
        }</tr
      ></ng-template>

      @if (tableConfig?.rowGroupOptions) {
        <ng-template pTemplate="rowexpansion" let-row let-index="rowIndex" let-columns="columns">
        @if (isExpanded(row)) {
          <tr
            class="fz-14"
            [style.background-color]="matchesRowBackgroundCondition(row) && !tableConfig.class.includes('striped') ? rowBackgroundColor : 'auto'"
            >
            @if (tableConfig.checkbox) {
              <td style="max-width: 2rem"></td>
            }
            @for (col of columns; track col; let IsFirst = $first) {
              <td
                [class]="col.class"
                [style]="col.style"
                [pEditableColumn]="col.editableConfig || null"
                [dir]="!col.editableConfig && (col.type === 'dateRange' || col.type === 'dateTimeRangeSplitWithPipe') ? 'rtl' : 'unset'"
                >
                @if (!col.editableConfig) {
                  <app-table-cell
                    [tableConfig]="tableConfig"
                    [row]="row"
                    [col]="col"
                    [class.pl-33]="IsFirst"
                    [isRowGroup]="true"
                    [labelCallbackFunction]="labelCallbackFunction"
                    [iconCallbackFunction]="iconCallbackFunction"
                  ></app-table-cell>
                }
                @if (col.editableConfig) {
                  <app-editable-table-cell [tableConfig]="tableConfig" [row]="row" [col]="col" [index]="index"></app-editable-table-cell>
                }
              </td>
            }
            @if (tableConfig.menuOptions?.length || tableConfig?.quickActionButton) {
              <td style="justify-content: flex-end"></td>
            }
            @if (tableConfig.buttonsColumn?.length) {
              <td [style]="'max-width:' + menuColumnWidth"></td>
            }
          </tr>
        }
        </ng-template>
      }

      @if (tableConfig?.virtualScrollLazyLoadOptions) {
        <ng-template pTemplate="loadingbody" let-columns="columns">
          <tr [style]="{ height: tableConfig?.virtualScrollLazyLoadOptions ? tableConfig.virtualScrollLazyLoadOptions.rowHeight : 'auto' }">
            @for (col of columns; track col) {
              <td>
                <p-skeleton></p-skeleton>
              </td>
            }
          </tr>
        </ng-template>
      }

      <ng-template pTemplate="footer">
        @if (tableConfig.customFooter && footer) {
          <ng-container [ngTemplateOutlet]="footer"></ng-container>
        }
      </ng-template>
      <ng-template pTemplate="emptymessage">
        @if (!tableConfig?.data?.length) {
          <tr>
            <td [attr.colspan]="columnsLength">
              <p-message severity="info" class="w-stretch">
                {{ 'COMMON.MESSAGES.NO_RESULTS' | translate }}
              </p-message>
            </td>
          </tr>
        }
      </ng-template>
    </p-table>

    <ng-content select="[table-other-content]"></ng-content>
  </div>
